(ns teamoesterreich.admin-mode.user.organisation-assign-modal
  (:require [reagent.core :as r]
            [reagent-material-ui.components :as mui]
            [teamoesterreich.admin-mode.data.rights :as d-rights]
            [teamoesterreich.admin-mode.component.org-selector :as org-selector]
            [teamoesterreich.util.helper :as h]             ;;(h/event-value e)
            [teamoesterreich.admin-mode.data.organisation :as d-organisation]
            [teamoesterreich.view-state :as v-state]
            [reagent-material-ui.icons.save :refer [save]]
            [reagent-material-ui.icons.keyboard-arrow-left :refer [keyboard-arrow-left]]
            [teamoesterreich.admin-mode.data.user :as d-user]
            [teamoesterreich.admin-mode.static-data :as staticData]
            [teamoesterreich.util.log :as log]))




(defn modal [!show !selected-user]
  (let [{:keys [user-uuid user-tomId user-orgId user-city user-zip user-firstName user-lastName]} @!selected-user
        !new-orgId (r/atom (or user-orgId ""))
        !organisations (r/cursor v-state/app-state [:organisations])

        ]
    (fn []
      (let [ALL_DST_LIST (or (into {} (d-organisation/get-all-multi-filter-list @!organisations)) {})]
        (when (nil? @!new-orgId) (reset! !new-orgId (or user-orgId "")))
        [mui/modal
         {
          :aria-labelledby  "simple-modal-title"
          :aria-describedby "simple-modal-description"
          :style            {:display        "flex"
                             :marginRight    "auto"
                             :marginLeft     "auto"
                             :alignItems     "center"
                             :justifyContent "center"}
          :open             (or @!show false)

          }
         [:div
          {
           :class "modal"
           :style {:width 600}}
          [:h2 "User einer Dienststelle zuordnen"]

          [mui/grid
           {:container  true
            :direction  "row"
            :alignItems "flex-start"
            :justify    "flex-start"
            :spacing    1
            }

           [mui/grid
            {:item true
             :lg   6
             :xs   12
             }
            [:span "Mitglied: "]
            [:span {:style {:color "darkblue"}} (str user-tomId ") " user-firstName " " user-lastName)]]

           [mui/grid
            {:item true
             :lg   6
             :xs   12
             }
            [:span "Wohnort: "]
            [:span {:style {:color "darkblue"}} (str user-zip " " user-city)]]

           [mui/grid
            {:item true
             :xs   12
             }
            [:span "Aktuelle Dienststelle: "]
            [:span {:style {:color "darkblue"}} (str (or (get ALL_DST_LIST user-orgId)
                                                         (str "-keine-")))]]


           [mui/grid
            {:item true
             :xs   12
             }
            [mui/form-control
             {
              :fullWidth true
              }
             [(org-selector/get-org-selector !new-orgId (d-rights/get-rights-orgId-filter d-rights/USER) {:border "" :multiple false :noDelete true})]
             ]
            ]
           ]



          [:br]
          [:br]
          [:br]
          [mui/button
           {:variant   "contained"
            :startIcon (r/as-element [keyboard-arrow-left])
            :style     {:marginRight 50}
            :onClick   (fn []
                         (reset! !new-orgId nil)
                         (reset! !show false))
            }
           "Abbrechen"]
          [mui/button
           {:color     "primary"
            :disabled  (= @!new-orgId (or user-orgId ""))
            :style     {:float "right"}
            :variant   "contained"
            :startIcon (r/as-element [save])
            :onClick   (fn []
                         (d-user/>user-edit-field user-uuid
                                                  {:user-orgId (or @!new-orgId "")}
                                                  (fn []
                                                    (d-user/actual-user-invalidate !selected-user)
                                                    (reset! !show false)
                                                    ))
                         )
            }
           "Speichern"]]
         ]
        ))))

